<template>
  <div class="settlement-page p-6 bg-gray-100 min-h-screen">
    <div class="bg-white p-4 rounded-lg shadow-md mb-4">
      <h3 class="text-lg font-semibold text-gray-800">Тооцоо нийлэх хүсэлтүүд</h3>
    </div>
    <div class="bg-white p-4 rounded-lg shadow-md" v-loading="settlementLoading">
      <div>
        <el-form
          :model="date"
          ref="date"
          label-position="top"
          :inline="true"
          size="mini"
        >
          <el-form-item label="Харилцагчийн нэр" prop="outlet_name">
            <el-select
              @change="currentPage = 1"
              reserve-keyword
              multiple
              filterable
              placeholder="Харилцагчийн нэр"
              clearable
              v-model="outlet_id"
            >
              <el-option
                v-for="item in allOutletList"
                :key="item._id"
                :label="item.outlet_name"
                :value="item._id"
              />
            </el-select>
          </el-form-item>
          <el-form-item prop="start_date" label="Эхлэх огноо">
            <el-date-picker
              @change="currentPage = 1"
              v-model="date.start_date"
              type="date"
              placeholder="Эхлэх огноо"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions1"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="end_date" label="Дуусах огноо">
            <el-date-picker
              @change="currentPage = 1"
              v-model="date.end_date"
              type="date"
              placeholder="Дуусах огноо"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions2"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="Төлөв">
            <el-select
              clearable
              v-model="status_code"
              @change="currentPage = 1"
              placeholder="Сонгох"
            >
              <el-option
                v-for="item in status"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="whitespace">
            <el-button
              type="primary"
              @click="getSettlement()"
              icon="el-icon-search"
              >Хайх
            </el-button>
            <el-button
              style="background-color: #1d6f42; color: #fff"
              size="mini"
              icon="el-icon-download"
              align="right"
              plain
              @click="excelDownload"
              :loading="excelLoading"
              >Татаж авах (.xlsx)</el-button
            >
            <el-button
              type="info" @click="disableMultipleWithdrawStatus"
              :disabled="isDisable"
              >Төлөв идэвхгүй болгох
            </el-button>
            <el-button
              :disabled="isDisable"
              type="success"
              @click="enableMultipleWithdrawStatus"
            >Төлөв идэвхтэй болгох
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        v-if="settlementData"
        empty-text="Өгөгдөл байхгүй байна."
        :data="settlementData"
        :row-key="row => row.id"
        :expand-row-keys="expandedKeys"
        @expand-change="handleExpandChange"
        style="width: 100%"
      >
        <el-table-column type="expand" width="80%">
          <template>
            <el-table
              empty-text="Өгөгдөл байхгүй байна."
              v-loading="expandedLoading"
              :data="days"
              style="width: 100%"
              :show-header="false"
              @row-click="showDayDetail"
            >
              <el-table-column width="180px"></el-table-column>
              <el-table-column width="180px"></el-table-column>
              <el-table-column width="150px">
                <template slot-scope="prop">
                  {{ formatDate(prop.row.date, "MM/DD") }}
                </template>
              </el-table-column>
              <el-table-column
                width="100px"
                prop="order_count"
              ></el-table-column>
              <el-table-column width="150px">
                <template slot-scope="prop">
                  {{ formatPrice(prop.row.total_sales) }}₮
                </template>
              </el-table-column>
              <el-table-column width="150px">
                <template slot-scope="prop">
                  {{ formatPrice(prop.row.net_sales) }}₮
                </template>
              </el-table-column>
              <el-table-column width="150px">
                <template slot-scope="prop">
                  <el-tag v-if="prop.row.isZoruu" type="danger" size="small"
                    >Зөрүүтэй</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column width="150px">
                <template
                  slot-scope="prop"
                  v-if="prop.row.is_canceled === true"
                >
                  <el-tag size="small" type="danger"
                    >Цуцалсан({{
                      prop.row.order_count - prop.row.success_count
                    }})</el-tag
                  >
                </template></el-table-column
              >
              <el-table-column width="150px">
                <template slot-scope="prop">
                  commission: {{ prop.row.commission }}
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column label="Төлөв" width="80px">
          <template slot-scope="scope">
            <el-switch
              :disabled="isDisable"
              v-model="scope.row.is_withdraw_enabled"
              active-color="#13ce66"
              @change="isWithdrawEnabled(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="settlement_id" label="Дугаар" width="80px">
        </el-table-column>
        <el-table-column prop="diamond_code" label="Diamond код" width="100px">
        </el-table-column>
        <el-table-column width="120" label="Эхний үлдэгдэл">
          <template slot-scope="prop">
            {{ formatPrice(prop.row.previous_amount) }}₮
          </template>
        </el-table-column>
        <el-table-column prop="partner_name" label="Outlet нэр" width="200">
        </el-table-column>
        <el-table-column prop="company_name" label="Компаний нэр" width="200">
        </el-table-column>
        <el-table-column
          prop="vat_regno"
          label="Регистерийн дугаар"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="bank_account_name"
          label="Хүлээн авагчийн банкны нэр"
          width="180"
        >
        </el-table-column>
        <el-table-column prop="bank_name" label="Банкны нэр" width="150">
        </el-table-column>
        <el-table-column
          prop="bank_account_number"
          label="Дансны дугаар"
          width="150"
        >
      </el-table-column>
        <el-table-column
          prop="sms_count"
          label="SMS тоо"
          width="150"
        >
        </el-table-column>
        <el-table-column label="Огноо" width="150">
          <template slot-scope="prop">
            {{ formatDate(prop.row.start_date, "MM/DD") }} -
            {{ formatDate(prop.row.end_date, "MM/DD") }}
          </template>
        </el-table-column>
        <el-table-column width="100" label="Захиалга" prop="order_count">
        </el-table-column>
        <el-table-column width="150" label="Меню дүн">
          <template slot-scope="prop">
            {{ formatPrice(prop.row.total_sales) }}₮
          </template>
        </el-table-column>
        <el-table-column width="120" label="Шимтгэл">
          <template slot-scope="prop">
            {{
              prop.row.net_sales !== null
                ? formatPrice(prop.row.net_sales)
                : "-"
            }}₮
          </template>
        </el-table-column>
        <el-table-column width="120" label="Хүлээн авах дүн">
          <template slot-scope="prop">
            {{ formatPrice(prop.row.huleen_awah_dun) }}₮
          </template>
        </el-table-column>
        <el-table-column prop="zoruu_dun" label="Зөрүү дүн"> </el-table-column>
        <el-table-column width="100" label="Төлөв" fixed="right">
          <template slot-scope="prop">
            <el-tag
              v-if="prop.row.status_code === 10"
              size="mini"
              class="mr10"
              >{{ prop.row.status }}</el-tag
            >
            <el-tag
              v-else-if="prop.row.status_code === 21"
              type="danger"
              size="mini"
              class="mr10"
              >{{ prop.row.status }}</el-tag
            >
            <!-- [10, 21, 20].includes(props.row.status_code) -->
            <el-tag
              v-else-if="prop.row.status_code === 20"
              type="success"
              size="mini"
              class="mr10"
              >{{ prop.row.status }}</el-tag
            >
            <el-tag
              v-else-if="prop.row.status_code === 100"
              effect="plain"
              type="success"
              size="mini"
              class="mr10"
              >{{ prop.row.status }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column fixed="right">
          <template slot-scope="prop">
            <div
              style="float: right"
              v-if="![90, 100].includes(prop.row.status_code)"
            >
              <el-tooltip content="Хасах" placement="top">
                <i
                  class="el-icon-remove-outline"
                  style="font-size: 1.6rem; color: #fe4b4b"
                  @click="minusDifference(prop.row)"
                >
                </i>
              </el-tooltip>
            </div>
            <div
              style="float: left"
              v-if="![90, 100].includes(prop.row.status_code)"
            >
              <el-tooltip content="Нэмэх" placement="top">
                <i
                  class="el-icon-circle-plus-outline"
                  size="mini"
                  style="font-size: 1.6rem"
                  @click="additionalDifference(prop.row)"
                >
                </i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Тайлбар(гараас)" width="200px" prop="settlement_note">
          <template slot-scope="scope">
            <span style="overflow-wrap: normal; word-break: normal;">
              {{ !['', null, 'null', undefined].includes(scope.row.settlement_note) ? scope.row.settlement_note : '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Тайлбар" width="120">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.is_declined_by_client"
              type="info"
              size="mini"
              v-loading="load"
              @click="explain(scope.row)"
              >Тайлбар</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="Буулгах огноо" width="200">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.withdraw_promised_time"
              :disabled="!scope.row.is_promised_time_editable"
              @click="handleclick(scope.row)"
              >
              {{ scope.row.withdraw_promised_time }}
              </el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          width="120"
          prop="withdraw_status_text"
          label="Төлбөрийн төлөв"
        />
        <el-table-column
          width="120"
          prop="balance_sent_date"
          label="Төлөгдсөн огноо"
        />
        <el-table-column width="120" label="Нийт буулгах дүн">
          <template slot-scope="prop">
            {{ formatPrice(prop.row.withdraw_amount_calculated) }}₮
          </template>
        </el-table-column>
        <el-table-column
          width="120"
          prop="order_canceled_count"
          label="Цуцлалтын тоо"
        />
        <el-table-column
          width="120"
          prop="outlet_delayed_order_count"
          label="Амжаагүй захиалгын тоо"
        />
        <el-table-column width="120" prop="settlement_delay_count" label="Хойшлүүлах боломжит өдөр" />
        <el-table-column width="180px">
          <template slot-scope="scope">
            <el-button
              type="success"
              :disabled="scope.row.status_code !== 100"
              v-model="scope.row.outlet_id"
              active-color="#13ce66"
              @click="emailRecovery(scope.row.settlement_id, scope.row.outlet_id)"
            >Мэйл нөхөж авах</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="text-right mt10"
        background
        layout="total, prev, pager, next"
        :page-count="pageCount"
        :current-page.sync="currentPage"
        :total="totalCount"
        :page-size="pageSize"
        @current-change="getSettlement"
        :page-sizes="[5, 10, 15, 20]"
      >
      </el-pagination>
    </div>
    <settlementDetail
      v-if="detailOutletId && currentDay"
      :isShow="orderListDialogVisible"
      :closeDialogDetail="closeDialogDetail"
      :close="closeDialogDetail"
      :addDifference="addDifference"
      :formatDate="formatDate"
      :formatPrice="formatPrice"
      :currentDay="currentDay"
      :current="current"
      :outletId="detailOutletId"
    ></settlementDetail>
    <isZoruu
      :isShow="diffirenceDialogVisible"
      :closeFunction="closeFunction"
      :currentZoruu="currentZoruu"
      :close="closeFunction"
      :saveDifference="saveDifference"
      :differenceLoading="differenceLoading"
    ></isZoruu>
    <!-- <promisedTimeDialog
      :isShow="promisedTimeDialogVisible"
      :closeFunction="promisedTimeDialogClose"
      :close="promisedTimeDialogClose"
      :onPressSave="onPressSave"
    ></promisedTimeDialog> -->
    <additional-settlement-dialog
      :getSettlementFunction="getSettlement"
      :isShow="additionalDialogVisible"
      :closeFunction="addDialogCloseFunc"
      :close="addDialogCloseFunc"
      :outletId="outletId"
      :additionalValue="additionalValue"
    ></additional-settlement-dialog>
    <minus-settlement-dialog
      :getSettlementFunction="getSettlement"
      :outletId="outletId"
      :isShow="minusDialogVisible"
      :closeFunction="closedFunction"
      :close="closedFunction"
      :minusValue="minusValue"
    ></minus-settlement-dialog>
    <!-- :updateValue="updateValue"
    :formatDate="formatDate"
    :saveDifference="saveDifference" -->
    <el-dialog
      v-if="confirmOrder"
      :title="'Та итгэлтэй байна уу?'"
      :visible.sync="confirmDialogVisible"
      v-loading="confirmLoading"
      width="400px"
      style="align-items: center"
    >
      <div slot="footer">
        <el-button @click="confirmDialogVisible = false">Үгүй</el-button>
        <el-button type="primary" @click="changeSettlementStatus"
          >Тийм</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="Буух цаг"
      :visible.sync="promisedTimeDialogVisible"
      :close-on-click-modal="promisedTimeDialogVisible"
      @close="promisedTimeDialogClose"
      @closed="promisedTimeDialogClose"
      width="25%"
      >
        <el-form>
          <el-form-item>
              <el-date-picker
                  style="width: 100%"
                  v-model="selectedPromisedTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="Буух цаг">
              </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="promisedTimeDialogClose">Болих</el-button>
          <el-button type="success" @click="onPressSave">Хадгалах</el-button>
        </div>
      </el-dialog>
    <explain-dialog
      :isShow="explainVisible"
      :closeFunction="closeExplainFunction"
      :explainValue="explainValue"
    ></explain-dialog>
  </div>
</template>

<script>
import settlementDetail from './components/settlementDialogs/settlementDetailDialog.vue'
import isZoruu from './components/settlementDialogs/zoruuDialog.vue'
// import promisedTimeDialog from './components/settlementDialogs/promisedTimeDialog.vue'
import { imgUrl2Base64 } from 'url2base64-js'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import services from '@/helpers/partnerServices.js'
import helper from '@/helpers/helper'
import minusSettlementDialog from './components/settlementDialogs/minusSettlementDialog.vue'
import additionalSettlementDialog from './components/settlementDialogs/additionalSettlementDialog.vue'
import explainDialog from './components/settlementDialogs/explainDialog.vue'
import XLSX from 'xlsx'
import { getGroups, getEmail } from '@/utils/auth.js'
pdfMake.vfs = pdfFonts.pdfMake.vfs
export default {
  name: 'Settlement',
  components: {
    isZoruu,
    settlementDetail,
    minusSettlementDialog,
    additionalSettlementDialog,
    explainDialog
    // promisedTimeDialog
  },
  data () {
    return {
      days: [],
      selectedPromisedTime: '',
      expandedKeys: [],
      expandedLoading: false,
      excelLoading: false,
      detailOutletId: '',
      outletId: '',
      outlets: [],
      reject: [],
      agree: [],
      settlementLoading: false,
      settlementData: null,
      orderListDialogVisible: false,
      diffirenceDialogVisible: false,
      declineDialogVisible: false,
      confirmDialogVisible: false,
      selectedSettlementId: '',
      promisedTimeDialogVisible: false,
      differenceLoading: false,
      declineLoading: false,
      confirmLoading: false,
      outlet_id: null,
      currentDay: null,
      current: null,
      currentZoruu: null,
      confirmOrder: null,
      predictLoading: false,
      predictSettlementData: null,
      data: true,
      saveSettlementStatus: null,
      status_code: '',
      whitespace: '\xa0',
      currentPage: null,
      pageCount: null,
      totalCount: null,
      pageSize: null,
      page: 0,
      allOutletList: [],
      date: {
        start_date: null,
        end_date: null
      },
      pickerOptions1: {
        firstDayOfWeek: 1
        // disabledDate (time) {
        //   return time.getTime() > Date.now()
        // }
      },
      pickerOptions2: {
        firstDayOfWeek: 1
        // disabledDate (time) {
        //   return time.getTime() > Date.now()
        // }
      },
      status: [
        {
          value: 10,
          label: 'Үүсгэсэн'
        },
        {
          value: 19,
          label: 'Харилцагчаас зөрүүтэй'
        },
        {
          value: 20,
          label: 'Санхүү зөвшөөрсөн'
        },
        {
          value: 21,
          label: 'Харилцагч зөвшөөрсөн'
        },
        {
          value: 22,
          label: 'Төлбөр автоматаар баталгаажсан зөвшөөрсөн'
        },
        {
          value: 30,
          label: 'Төлбөр буугаагүй'
        },
        {
          value: 31,
          label: 'Идэвхигүй'
        },
        {
          value: 32,
          label: 'Идэвхитэй'
        },
        {
          value: 90,
          label: 'Төлбөр хүлээгдэж байгаа'
        },
        {
          value: 91,
          label: 'Цуцалсан захиалга'
        },
        {
          value: 100,
          label: 'Төлбөр буусан'
        }
      ],
      loadUpload: false,
      name: 'xoxo',
      selectedSettlement: JSON.parse(
        window.localStorage.getItem('settlementSelectData')
      ),
      confirmButtonType: true,
      minusValue: null,
      minusDialogVisible: false,
      additionalValue: null,
      additionalDialogVisible: false,
      explainVisible: false,
      explainValue: null,
      group: [],
      isDisable: false,
      email: '',
      load: false
    }
  },
  async created () {
    this.getSettlement()
    // this.getSettlementData()
    this.email = await getEmail()
  },
  methods: {
    handleclick (data) {
      this.selectedPromisedTime = data.withdraw_promised_time
      this.selectedSettlementId = data.settlement_id
      this.promisedTimeDialogVisible = true
    },
    handleExpandChange (row, expanded) {
      this.detailOutletId = row.outlet_id
      row && this.expandedKeys.includes(row.id) ? this.expandedKeys = this.expandedKeys.filter(key => key !== row.id) : this.expandedKeys = [row.id]
      if (expanded.length > 0) {
        this.expandedLoading = true
        const payload = {
          outlet_id: row.outlet_id,
          start_date: row.start_date,
          end_date: row.end_date
        }
        services.getSettlementDayData(payload).then((response) => {
          if (response.data.status === 'success') {
            this.days = response.data.data
            this.expandedLoading = false
          } else {
            this.days = []
            this.expandedLoading = false
          }
        })
      }
    },
    async onPressSave () {
      const payload = {
        settlement_id: this.selectedSettlementId.toString(),
        update_time: this.selectedPromisedTime
      }

      const { data } = await services.updateWithdrawPromisedTime(payload)

      if (data.status === 'success') {
        this.promisedTimeDialogVisible = false
        this.getSettlement()
        this.$notify.success({
          title: 'Амжилттай',
          position: 'bottom-left',
          message: 'Амжилттай төлөв шинэчлэгдлээ.',
          duration: 2000
        })
      } else {
        this.$notify.error({
          title: 'Уучлаарай',
          position: 'bottom-left',
          message: 'Төлөв өөрчлөхөд алдаа гарлаа',
          duration: 2000
        })
      }
    },
    excelDownload () {
      this.excelLoading = true
      const payload = {
        start_date: this.date.start_date,
        end_date: this.date.end_date,
        status_code: this.status_code,
        page: this.currentPage,
        email: this.email
      }
      if (
        this.outlet_id &&
        Array.isArray(this.outlet_id) &&
        this.outlet_id.length > 0
      ) {
        payload.outlet_id = this.outlet_id
      }
      services.downloadSettlement(payload).then((response) => {
        if (response && response.data) {
          const data = response.data.data
          const reportXlsx = XLSX.utils.json_to_sheet(data)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, reportXlsx, 'settlementList')
          const currentdate = new Date()
          const datetime =
            currentdate.getFullYear() +
            '_' +
            currentdate.getDate() +
            '_' +
            (currentdate.getMonth() + 1) +
            ' ' +
            currentdate.getHours() +
            '_' +
            currentdate.getMinutes() +
            '_' +
            currentdate.getSeconds()
          XLSX.writeFile(wb, 'settlementList' + datetime + '.xlsx')
        }
        this.excelLoading = false
      })
    },
    async enableMultipleWithdrawStatus () {
      try {
        await this.$confirm(
          'Та төлөв идэвхтэй болгохдоо итгэлтэй байна уу?',
          'Анхааруулга',
          {
            confirmButtonText: 'Тийм',
            cancelButtonText: 'Үгүй',
            type: 'warning'
          }
        )

        this.settlementLoading = true

        const payload = {
          start_date: this.date.start_date,
          end_date: this.date.end_date,
          status_code: this.status_code,
          page: this.currentPage,
          email: this.email,
          ...(this.outlet_id?.length ? { outlet_id: this.outlet_id } : {})
        }

        const { data } = await services.enableMultipleWithdrawStatus(payload)

        if (data?.data?.status === 'success') {
          this.$notify.success({
            title: 'Амжилттай',
            position: 'bottom-left',
            message: 'Амжилттай төлөв шинэчлэгдлээ.',
            duration: 2000
          })
          this.getSettlement()
        } else {
          this.$notify.error({
            title: 'Уучлаарай',
            position: 'bottom-left',
            message: data?.data?.message || 'Алдаа гарлаа',
            duration: 2000
          })
        }
      } catch (error) {
        if (error === 'cancel') {
          this.$message({
            type: 'info',
            message: 'Буцсан'
          })
        } else {
          this.$notify.error({
            title: 'Алдаа',
            position: 'bottom-left',
            message: error?.response?.data?.message || 'Серверийн алдаа гарлаа',
            duration: 2000
          })
        }
      } finally {
        this.settlementLoading = false
      }
    },
    async disableMultipleWithdrawStatus () {
      try {
        await this.$confirm(
          'Та төлөв идэвхгүй болгохдоо итгэлтэй байна уу?',
          'Анхааруулга',
          {
            confirmButtonText: 'Тийм',
            cancelButtonText: 'Үгүй',
            type: 'warning'
          }
        )

        this.settlementLoading = true

        const payload = {
          start_date: this.date.start_date,
          end_date: this.date.end_date,
          status_code: this.status_code,
          page: this.currentPage,
          email: this.email,
          ...(this.outlet_id?.length ? { outlet_id: this.outlet_id } : {})
        }

        const { data } = await services.disableMultipleWithdrawStatus(payload)

        const isSuccess = data?.data?.status === 'success'

        this.$notify[isSuccess ? 'success' : 'error']({
          title: isSuccess ? 'Амжилттай' : 'Уучлаарай',
          position: 'bottom-left',
          message: isSuccess
            ? 'Амжилттай төлөв шинэчлэгдлээ.'
            : data?.data?.message || 'Алдаа гарлаа',
          duration: 2000
        })

        if (isSuccess) {
          this.getSettlement()
        }
      } catch (error) {
        if (error === 'cancel') {
          this.$message({
            type: 'info',
            message: 'Буцсан'
          })
        } else {
          this.$notify.error({
            title: 'Алдаа',
            position: 'bottom-left',
            message: error?.response?.data?.message || 'Серверийн алдаа гарлаа',
            duration: 2000
          })
        }
      } finally {
        this.settlementLoading = false
      }
    },
    async isWithdrawEnabled (data) {
      this.settlementLoading = true

      try {
        const payload = {
          settlement_id: data.settlement_id,
          is_withdraw_enabled: data.is_withdraw_enabled,
          email: this.email
        }

        const { data: response } = await services.disableWithdrawStatus(payload)

        this.$notify[response?.data === 'success' ? 'success' : 'error']({
          title: response?.data === 'success' ? 'Амжилттай' : 'Уучлаарай',
          position: 'bottom-left',
          message: response?.data === 'success'
            ? 'Амжилттай төлөв шинэчлэгдлээ.'
            : 'Алдаа гарлаа.',
          duration: 2000
        })
      } catch (error) {
        this.$notify.error({
          title: 'Алдаа',
          position: 'bottom-left',
          message: error?.response?.data?.message || 'Серверийн алдаа гарлаа.',
          duration: 2000
        })
      } finally {
        this.settlementLoading = false
      }
    },
    async explain (value) {
      this.load = true
      try {
        const payload = { settlement_id: value.settlement_id }

        const { data } = await services.getPartnerSettlementDescription(payload)

        if (data?.status === 'success') {
          this.explainValue = data.data
          this.explainVisible = true
        } else {
          this.$notify.error({
            title: 'Уучлаарай',
            position: 'bottom-left',
            message: data?.message || 'Алдаа гарлаа',
            duration: 2000
          })
        }
      } catch (error) {
        this.$notify.error({
          title: 'Алдаа',
          position: 'bottom-left',
          message: error?.response?.data?.message || 'Серверийн алдаа гарлаа',
          duration: 2000
        })
      } finally {
        this.load = false
      }
    },
    minusDifference (value) {
      this.minusValue = Object.assign({}, value)
      this.minusDialogVisible = true
    },
    additionalDifference (value) {
      this.additionalValue = Object.assign({}, value)
      this.additionalDialogVisible = true
      this.outletId = value.outlet_id
    },
    closeDialogDetail () {
      this.orderListDialogVisible = false
      this.currentDay = null
    },
    closeFunction () {
      this.diffirenceDialogVisible = false
      this.currentZoruu = null
    },
    addDialogCloseFunc () {
      this.additionalValue = null
      this.additionalDialogVisible = false
    },
    closedFunction () {
      this.minusValue = null
      this.minusDialogVisible = false
    },
    promisedTimeDialogClose () {
      this.promisedTimeDialogVisible = false
    },
    closeExplainFunction () {
      this.explainValue = null
      this.explainVisible = false
    },
    printSettlement (url) {
      const printWindow = window.open('')
      printWindow.document.write('<html><head>')
      printWindow.document.write(
        '</head><body ><img width="100%" height="100%" src=\''
      )
      printWindow.document.write(url)
      printWindow.document.write("' /></body></html>")
      printWindow.document.close()
      printWindow.print()
    },
    formatDate (date, format) {
      return helper.formatDate(date, format)
    },
    formatPrice (price) {
      return parseFloat(price).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    showDayDetail (row) {
      this.currentDay = Object.assign({}, row)
      this.orderListDialogVisible = true
      this.settlementData.forEach((element) => {
        this.current = element.status_code
      })
    },
    changeCurrentOutlet (id) {
      this.getSettlement(id)
    },
    async getSettlement () {
      this.group = await getGroups()
      if (this.group.includes('view')) this.isDisable = true
      const isValidStartDate = this.date.start_date !== null
      const isValidEndDate = this.date.end_date !== null
      if (isValidStartDate && isValidEndDate) {
        if (this.date.start_date > this.date.end_date) {
          this.$notify({
            title: 'Анхааруулга',
            message: 'Сонгосон хугацаагаар хайх боломжгүй байна',
            type: 'error'
          })
          return false
        }
      } else if (
        (isValidStartDate && !isValidEndDate) ||
        (isValidEndDate && !isValidStartDate)
      ) {
        this.$notify({
          title: 'Анхааруулга',
          message: 'Эхлэх болон дуусах хугацааг сонгоно уу',
          type: 'error'
        })
        return false
      }
      const payload = {
        start_date: this.date.start_date,
        end_date: this.date.end_date,
        status_code: this.status_code,
        page: this.currentPage
      }
      if (
        this.outlet_id &&
        Array.isArray(this.outlet_id) &&
        this.outlet_id.length > 0
      ) {
        payload.outlet_id = this.outlet_id
      }
      this.settlementLoading = true
      services.getSettlements(payload).then((response) => {
        this.data = response.data.success
        if (response.data.status !== 'success') {
          this.settlementData = []
          this.$notify.error({
            title: 'Уучлаарай',
            position: 'bottom-left',
            message: response.data.message,
            duration: 2000
          })
          return
        }

        if (
          Object.prototype.hasOwnProperty.call(response.data.data, 'data')
        ) {
          this.settlementData = response.data.data.data
          this.currentPage = response.data.data.current_page
          this.pageCount = response.data.data.last_page
          this.totalCount = response.data.data.total
          this.pageSize = response.data.data.per_page
        } else {
          this.settlementData = []
        }
        this.settlementLoading = false
      })
      services.getAllOutletName().then((res) => {
        if (res.data.status === 'success') {
          this.allOutletList = res.data.data
        }
      })
    },

    addDifference (order) {
      this.diffirenceDialogVisible = true
      this.currentZoruu = Object.assign({}, order)
    },
    confirm (order, statusCode) {
      this.confirmOrder = Object.assign({}, order)
      this.saveSettlementStatus = statusCode
      this.confirmDialogVisible = true
    },
    changeSettlementStatus () {
      this.confirmLoading = true
      services
        .changeSettlementStatus({
          settlement_id: this.confirmOrder.settlement_id,
          settlement_status: this.saveSettlementStatus
        })
        .then((response) => {
          if (response.data.status === 'success') {
            this.$notify.success({
              title: 'Амжилттай',
              position: 'bottom-left',
              message: ' Амжилттай',
              duration: 2000
            })
            this.confirmLoading = false
            this.confirmDialogVisible = false
            this.getSettlement()
          } else {
            this.$notify.error({
              title: 'Уучлаарай',
              position: 'bottom-left',
              message: response.data.message,
              duration: 2000
            })
            this.confirmLoading = false
          }
        })
      this.confirmDialogVisible = false
    },
    saveDifference () {
      if (
        this.currentZoruu.balance_note === '' &&
        this.currentZoruu.is_balance === true
      ) {
        this.$notify.error({
          title: 'Oops',
          position: 'bottom-left',
          message: 'Тэмдэглэл хоосон байна',
          duration: 2000
        })
        return false
      }
      if (this.currentZoruu.is_balance === false) {
        this.currentZoruu.balance_note = ''
      }
      this.differenceLoading = true
      services
        .saveDifference({
          order_id: this.currentZoruu.order_id,
          balance_note: this.currentZoruu.balance_note,
          is_balance: this.currentZoruu.is_balance
        })
        .then((response) => {
          if (response.data.status === 'success') {
            this.$notify.success({
              title: 'Амжилттай',
              position: 'bottom-left',
              message:
                this.currentZoruu.order_number +
                ' дугаартай захиалга зөрүү тэмдэглэлээ',
              duration: 2000
            })
            this.differenceLoading = false
            this.diffirenceDialogVisible = false
            this.getSettlement()
          } else {
            this.$notify.error({
              title: 'Уучлаарай',
              position: 'bottom-left',
              message: response.data.message,
              duration: 2000
            })
            this.differenceLoading = false
          }
        })
      this.diffirenceDialogVisible = false
      this.orderListDialogVisible = false
    },
    printPdf (data) {
      const startDate = this.formatDate(data.start_date, 'YYYY/MM/DD')
      const endDate = this.formatDate(data.end_date, 'YYYY/MM/DD')
      let imageBase64Convert = ''
      const urlStr = data.img_url
      imgUrl2Base64(urlStr, function (base64) {
        imageBase64Convert = base64
        const docDefinition = {
          content: [
            {
              layout: 'lightHorizontalLines',
              table: {
                headerRows: 2,
                widths: ['*', 'auto', 'auto', '*', '*'],
                body: [
                  [
                    'Нийт тоо',
                    'Илгээсэн хугацаа',
                    'Дуусах хугацаа',
                    'Борлуулалт',
                    'Шимтгэл'
                  ],
                  [
                    data.order_count,
                    startDate,
                    endDate,
                    data.total_sales,
                    data.net_sales
                  ]
                ]
              }
            },
            { text: 'Данс:', style: 'subheader' },
            {
              image: imageBase64Convert,
              width: 515,
              height: 600
            }
          ]
        }
        pdfMake.createPdf(docDefinition).open()
      })
    },
    async emailRecovery (id, outletId) {
      this.loading = true
      try {
        const { data } = await services.emailRecoveryOutlet({ id, outletId })

        const isSuccess = data?.status === 'success'

        this.$notify[isSuccess ? 'success' : 'error']({
          title: isSuccess ? 'Амжилттай' : 'Уучлаарай',
          position: 'bottom-left',
          message: isSuccess
            ? 'Амжилттай'
            : data?.message || 'Алдаа гарлаа',
          duration: 2000
        })
      } catch (error) {
        this.$notify.error({
          title: 'Уучлаарай',
          position: 'bottom-left',
          message: error?.message || 'Серверийн алдаа гарлаа',
          duration: 2000
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
